/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MessageViewFileDto { 
    /**
     * Идентификатор файла
     */
    fileId: string;
    /**
     * Имя файла
     */
    fileName: string | null;
    /**
     * тип контента файла (например, application/octet-stream)
     */
    contentType: string | null;
    /**
     * Размер файла в байтах
     */
    size?: number;
}

